import { get } from "lodash"

// Config map cho Data Sharing Management page (/admin/sharing).
// entityType = giá trị thật trong backend EntityTypes.java (gratipos-api phase 17/19).
// nameFunction = hàm list thật export trong src/services/api.js, gọi qua this.$api[nameFunction].
// companyParam = key mà nameFunction đọc trong `where` để lọc theo company chủ sở hữu
//   ("companies.id" | "companyId" | null nếu backend tự suy companyId, vd catalog_item đọc localStorage).
// nameField = field hiển thị làm tên/nhãn chính trên DataTable.
// nameFunction: null đánh dấu entity chưa có list fn tương thích DataTable (v1 scoped-out, xem plan phase-02).
export const SHARABLE_ENTITY_TYPES = [
  { entityType: "large_groups", label: "Nhóm hàng lớn", nameFunction: "getLargeGroups", companyParam: "companies.id", nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },
  { entityType: "middle_groups", label: "Nhóm hàng vừa", nameFunction: "getMiddleGroups", companyParam: "companies.id", nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },
  { entityType: "small_groups", label: "Nhóm hàng nhỏ", nameFunction: "getSmallGroups", companyParam: "companies.id", nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },
  // getProducts không tách companyId riêng (findProducts schema không có $companyId) — suy theo convention
  // large/middle/small_groups cùng loại reference-data dùng "companies.id". Chưa verify được từ backend source.
  // findProducts CŨNG bắt buộc $branchId: Int! (duy nhất trong 20 nameFunction) — getProducts() đọc where["branchId"].
  { entityType: "products", label: "Sản phẩm", nameFunction: "getProducts", companyParam: "companies.id", nameField: "name", searchKey: ["name_fulltextBool", "name_ilike"], needsBranchId: true, codeField: "code", codeSearchKey: "code_ilike" },
  { entityType: "customers", label: "Khách hàng", nameFunction: "getCustomers", companyParam: "companies.id", nameField: "customerName", searchKey: ["customerName_ilike", "phoneNumber_ilike"], codeField: "customerCode", codeSearchKey: "customerCode_ilike" },
  // getSuppliers(where) — không nhận limit/skip/orderBy → DataTable không có server paging cho tab này (v1 chấp nhận).
  { entityType: "suppliers", label: "Nhà cung cấp", nameFunction: "findSuppliers", companyParam: "companyId", nameField: "supplierName", searchKey: ["supplierName_ilike", "note_ilike"], noPaging: true, codeField: "supplierCode", codeSearchKey: "supplierCode_ilike" },
  { entityType: "brands", label: "Thương hiệu", nameFunction: "findBrands", companyParam: "companyId", nameField: "name", searchKey: "name_ilike" },
  // getProductUnits(where) — không nhận limit/skip/orderBy, không tách companyId (findProductUnits schema không có $companyId).
  { entityType: "product_units", label: "Đơn vị tính", nameFunction: "getProductUnits", companyParam: "companies.id", nameField: "name", searchKey: "name_ilike", noPaging: true },
  { entityType: "price_level", label: "Bảng giá", nameFunction: "findPriceLevel", companyParam: "companyId", nameField: "name", searchKey: "name_ilike" },
  { entityType: "discounts", label: "Chiết khấu", nameFunction: "getDiscounts", companyParam: "companyId", nameField: "code", searchKey: ["code_ilike", "description_ilike"] },
  { entityType: "membership_rank", label: "Hạng thành viên", nameFunction: "getMembershipRank", companyParam: "companies.id", nameField: "rankName", searchKey: "rankName_ilike" },
  { entityType: "customer_group", label: "Nhóm khách hàng", nameFunction: "getCustomerGroups", companyParam: "companies.id", nameField: "groupName", searchKey: "groupName_ilike" },
  // getChannels(companyId) — signature không tương thích DataTable(where,limit,skip,orderBy). Ẩn tab v1 (xem unresolved questions).
  { entityType: "sales_channels", label: "Kênh bán", nameFunction: null, companyParam: null, nameField: null },
  { entityType: "catalog_item", label: "Danh mục", nameFunction: "getCatalogItems", companyParam: null, nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },

  // --- Backend phase-19, chưa land (config sẵn, tab tự ẩn nếu group.sharedEntityTypes chưa có) ---
  { entityType: "lead", label: "Lead", nameFunction: "getLeads", companyParam: "companyId", nameField: "fullName", searchKey: ["fullName_like", "email_like", "phone_like"], codeField: "leadCode", codeSearchKey: "leadCode_like" },
  { entityType: "campaign", label: "Chương trình KM", nameFunction: "getCampaigns", companyParam: "companyId", nameField: "name", searchKey: ["name_ilike", "description_ilike"] },
  { entityType: "customer_care", label: "Chăm sóc KH", nameFunction: "getCustomerCare", companyParam: "companyId", nameField: "title", searchKey: "title_ilike" },
  { entityType: "customer_care_type", label: "Loại CSKH", nameFunction: "getCustomerCareTypes", companyParam: "companyId", nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },
  // Chưa có list fn trong api.js — backend phase-19 sẽ bổ sung resolver + client cần thêm hàm tương ứng khi đó.
  { entityType: "feedbacks", label: "Phản hồi", nameFunction: null, companyParam: null, nameField: null },
  { entityType: "product_variant", label: "Biến thể SP", nameFunction: "findProductVariant", companyParam: "companyId", nameField: "name", searchKey: "name_ilike", codeField: "code", codeSearchKey: "code_ilike" },
  { entityType: "product_custom_data", label: "Dữ liệu tùy biến SP", nameFunction: null, companyParam: null, nameField: null },
  { entityType: "bom", label: "Định mức (BOM)", nameFunction: "getBOMs", companyParam: "companyId", nameField: "bomName", searchKey: ["bomName_ilike", "bomDescription_ilike"], codeField: "bomCode", codeSearchKey: "bomCode_ilike" },
  // ProductSupplier là bảng nối product+supplier, không có field tên riêng — hiển thị id v1.
  // codeField trỏ vào sản phẩm liên kết (products.code) vì bản thân ProductSupplier không có code riêng.
  // codeSearchKey cố ý bỏ trống: backend không hỗ trợ filter theo field lồng "products.code".
  { entityType: "product_supplier", label: "NCC sản phẩm", nameFunction: "findProductSupplier", companyParam: "companyId", nameField: "id", searchKey: "id_eq", codeField: "products.code" },
  { entityType: "shipping_booking", label: "Booking vận chuyển", nameFunction: "getShippingBooking", companyParam: "companyId", nameField: "name", searchKey: ["name_ilike", "code_ilike"], codeField: "code", codeSearchKey: "code_ilike" },
]

export const getEntityConfig = (entityType) =>
  SHARABLE_ENTITY_TYPES.find((e) => e.entityType === entityType)

// DataTable dùng nameFunction để lấy dữ liệu. Tra ngược từ hàm này giúp nút
// chia sẻ xuất hiện nhất quán tại mọi màn hình đang hiển thị loại dữ liệu đó.
// Những alias dưới đây là các hàm list đang được dùng ở các màn hình cũ.
export const getEntityConfigByNameFunction = (nameFunction) => {
  const aliases = {
    getProductList: "products",
  }
  const entityType = aliases[nameFunction]
  return SHARABLE_ENTITY_TYPES.find(
    (e) => e.nameFunction === nameFunction || e.entityType === entityType,
  )
}

export const getEnabledConfigs = (sharedEntityTypes = []) =>
  SHARABLE_ENTITY_TYPES.filter((e) => sharedEntityTypes.includes(e.entityType))

export const buildSharingParams = (cfg, companyId, branchId) => {
  const params = {}
  if (cfg.companyParam === "companies.id") params["companies.id"] = companyId
  if (cfg.companyParam === "companyId") params.companyId = companyId
  if (cfg.needsBranchId) params.branchId = branchId
  return JSON.stringify(params)
}

// Cột tối giản cho DataTable: id, (mã code nếu có), nhãn tên, badge trạng thái share.
// sharedIdSet: Set<string> id đã share (từ $api.sharedRecords), dùng đánh dấu badge (khi không bật ALL).
// excludedIdSet: Set<string> id owner đã loại trừ khỏi rule ALL (từ $api.sharedExclusions).
// shareAllOn: true khi group đang có rule ALL cho entityType này (từ $api.sharingRules).
export const getFieldSharing = (_this, cfg, sharedIdSet = new Set(), excludedIdSet = new Set(), shareAllOn = false) => [
  {
    key: "id",
    title: "ID",
    width: cfg.codeField ? "10%" : "15%",
    searchKey: "id_eq",
  },
  ...(cfg.codeField
    ? [
        {
          key: cfg.codeField,
          title: "Mã code",
          width: "15%",
          searchKey: cfg.codeSearchKey,
          noSort: cfg.codeField.includes("."), // path lồng (vd product_supplier.products.code) -> backend không sort được
          showData: (r) => get(r, cfg.codeField) || "",
        },
      ]
    : []),
  {
    key: cfg.nameField || "id",
    title: cfg.label,
    width: cfg.codeField ? "40%" : "55%",
    searchKey: cfg.searchKey,
    showData: (r) => (cfg.nameField ? r[cfg.nameField] : r.id) || "",
  },
  {
    key: "__shared",
    title: "Trạng thái chia sẻ",
    width: cfg.codeField ? "35%" : "30%",
    className: "text-center",
    noSort: true, // cột tổng hợp client-side, không phải field thật trên entity -> không cho sort (tránh gửi orderBy sai lên backend)
    showData: (r) => {
      const id = String(r.id)
      if (shareAllOn) {
        return excludedIdSet.has(id)
          ? `<span class="badge badge-warning">Đã loại trừ</span>`
          : `<span class="badge badge-success">Đã chia sẻ</span>`
      }
      return sharedIdSet.has(id)
        ? `<span class="badge badge-success">Đã chia sẻ</span>`
        : `<span class="badge badge-secondary">Chưa chia sẻ</span>`
    },
  },
]
